const isValidSpecValue = (value) =>
  value !== undefined && value !== null && value !== "";

export const specificationsToMap = (specifications) => {
  const map = {};
  if (!Array.isArray(specifications)) return map;

  specifications.forEach((spec) => {
    if (!spec) return;
    const key = String(spec.key || spec.label || "").trim();
    if (!key || !isValidSpecValue(spec.value)) return;
    map[key] = spec.value;
    map[key.toLowerCase()] = spec.value;
  });

  return map;
};

export const getSpecsMap = (product) => {
  const map = specificationsToMap(product?.specifications);

  const legacy =
    product?.dynamicFields ||
    product?.customFields ||
    product?.fields ||
    product?.specs ||
    null;

  if (legacy && typeof legacy === "object") {
    Object.entries(legacy).forEach(([key, value]) => {
      if (!isValidSpecValue(value)) return;
      const normalizedKey = String(key || "").trim();
      if (!normalizedKey) return;
      map[normalizedKey] = value;
      map[normalizedKey.toLowerCase()] = value;
    });
  }

  return map;
};

export const getSpecValue = (product, fieldName) => {
  if (!fieldName) return undefined;
  const map = getSpecsMap(product);
  const direct = map[fieldName];
  if (isValidSpecValue(direct)) return direct;
  const normalized = String(fieldName).toLowerCase();
  return map[normalized];
};
